import React, { useEffect, useState, useCallback } from 'react'
import { useHistory } from "react-router-dom";
import { TYPE_SUCCESS, TYPE_FAIL, INTERVAL } from 'assets/constants/Constants';
import { EDIT_ICON, TRASH_ICON, KEY_ICON } from "assets/constants/Icons";
import Spinner from 'components/Spinner';
import ShowToast from 'components/ShowToast';
import MaterialTable from "material-table";
import { hasPermission } from 'components/Permission';
import { getUserList, getRoleListCall, deleteUserCall, UpdateUserCall } from "lib/axiosUtils";
import { ThemeProvider } from '@mui/styles';
import { createTheme } from '@mui/material';
import ResetPasswordComponent from 'components/ResetPasswordComponent';
import "./user-style.css";
import AuditReport from "components/ProjectTracking/AuditReport";

const UserPage = (props) => {
   const history = useHistory();
   const [isLoading, setIsLoading] = useState(true);
   const [userList, setUserList] = useState([]);
   const [roleList, setRoleList] = useState([]);
   const [openResetPasswordModal, setOpenResetPasswordModal] = useState(false);
   const [userData, setUserData] = useState(null);
   const mytheme = createTheme({});
   const buttonText = "Add User";
   const userDetail = JSON.parse(localStorage.getItem("userData"));

   useEffect(() => {
      const fetchData = async () => {
         try {
            const userData = await getUserList({}, {});
            const roleData = await getRoleListCall({}, {});
            setUserList(userData.data.result);
            setRoleList(roleData.data.result);
         } catch (error) {
            console.error("Error occurred while fetching data", error);
         } finally {
            setIsLoading(false);
         }
      };

      fetchData();
   }, []);

   const resetPasswordHandler = (rowData) => {
      setUserData(rowData);
      setOpenResetPasswordModal(true);
   }

   const addEditUserHandler = (item) => {
      if (item) {
         const rowItem = {
            _id: item.userId,
            first_name: item.firstName,
            last_name: item.lastName,
            email_id: item.emailId,
            phone_number: item.phoneNumber,
            username: item.username,
            password: item.password,
            role: item.roleId,
            select_profile: item.selectProfile,
            company_id: item.selectedEmployer,
            employer_id: item.employerUnit,
            partner_id: item.selectedTrainingPartner,
         }
         history.push({
            pathname: "/create-user-page",
            state: { ...rowItem, isFromProfile: false },
         });
      } else {
         history.push({
            pathname: "/create-user-page",
            state: null
         });
      }
   }

   const handleDeleteUser = async (item) => {
      if (window.confirm("Are you sure you want to delete this user?")) {
         setIsLoading(true);
         const userId = userDetail?._id;
         const deleteResponse = await deleteUserCall({}, { userId }, item);
         if (deleteResponse.statusCode === 200) {
            const fetchResponse = await getUserList({}, {});
            setUserList(fetchResponse.data.result);
            ShowToast("User deleted successfully", TYPE_SUCCESS, INTERVAL, props, "");
         } else {
            ShowToast("Something went wrong. Please try again!", TYPE_FAIL, INTERVAL, props, "");
         }
      }
      setIsLoading(false);
   }

   const handleDelete = (item) => {
      handleDeleteUser(item.userId);
   };

   const cancelHandle = () => {
      setOpenResetPasswordModal(false);
   };

   const renderRole = useCallback(
      (roleId) => {
         return roleList
            .filter((r) => r._id === roleId)
            .map((r) => r.user_role)
            .join(", ");
      },
      [roleList]
   );

   const handleToggle = async (userId, currentFlag) => {
      if (window.confirm(`Are you sure you want to ${currentFlag ? "Disable" : "Enable"} Audit for this user?`)) {
         setIsLoading(true);
         const requestData = {
            auditflag: !currentFlag
         }
         const userResponse = await UpdateUserCall({}, requestData, userId);
         if (userResponse.statusCode === 200) {
            let fetchResponse = await getUserList({}, {});
            setUserList(fetchResponse.data.result);
            ShowToast(`Audit ${currentFlag ? "Disabled" : "Enabled"}`, TYPE_SUCCESS, INTERVAL, props, "");
         } else {
            ShowToast("Something went wrong, please try again", TYPE_FAIL, INTERVAL, props, "")
         }
         setIsLoading(false);
      }
   }


   return (
      <>
         {
            isLoading ? (
               <Spinner />
            ) : (
               <div className="main-content user-page-outer-wrapper">
                  <div className="list-wrapper">
                     <div className="back">
                        <ul className="breadcrumb1">
                           <li>User Master</li>
                        </ul>
                     </div>
                     {
                        hasPermission("user", "create") && (
                           <div className="user-button-view">
                              <button className="brand-button" onClick={() => addEditUserHandler(null)}>
                                 {buttonText}
                              </button>
                           </div>
                        )
                     }

                     <div className="mt-4 border list-table-div site-table" style={{ marginBottom: 50 }}>
                        {
                           userList.length > 0 ? (
                              <ThemeProvider theme={mytheme}>
                                 <MaterialTable
                                    columns={[
                                       {
                                          title: "Username", field: "username",
                                          cellStyle: { cellWidth: '12%', color: '#808080', fontSize: 14, textTransform: 'none' }
                                       },
                                       {
                                          title: "User", field: "user",
                                          cellStyle: { cellWidth: '18%', fontWeight: 'bolder', color: '#000000', fontSize: 14 }
                                       },
                                       {
                                          title: "Email Id", field: "emailId",
                                          cellStyle: { cellWidth: '20%', color: '#808080', fontSize: 14, textTransform: 'none' },
                                          sorting: false
                                       },
                                       {
                                          title: "Phone Number", field: "phoneNumber",
                                          cellStyle: { cellWidth: '12%', color: '#808080', fontSize: 14 },
                                          sorting: false
                                       },
                                       {
                                          title: "Role", field: "userRole",
                                          cellStyle: { cellWidth: '14%', color: '#808080', fontSize: 14 }
                                       },
                                       hasPermission("user", "audit") && (
                                          {
                                             title: "Audit",
                                             field: "audit",
                                             sorting: false,
                                             filtering: false,
                                             render: (rowData) => (
                                                <>
                                                   <label class="toggle-switch">
                                                      <input
                                                         type="checkbox"
                                                         checked={rowData.isAudit}
                                                         onChange={() => handleToggle(rowData.userId, rowData.isAudit)}
                                                      />
                                                      <span class="slider"></span>
                                                   </label>
                                                   <AuditReport userId={rowData.userId} isFromTracking={false} />
                                                </>
                                             ),
                                          }
                                       )
                                    ].filter(Boolean)}
                                    data={
                                       userList.map((item, index) => {
                                          return (
                                             {
                                                user: `${item.first_name} ${item.last_name}`,
                                                firstName: item.first_name,
                                                lastName: item.last_name,
                                                emailId: item.email_id,
                                                phoneNumber: item.phone_number,
                                                username: item.username,
                                                userRole: renderRole(item.role),
                                                password: item.password,
                                                confirmPassword: item.password,
                                                userId: item._id,
                                                roleId: item.role,
                                                selectProfile: item.select_profile,
                                                selectedEmployer: item.company_id,
                                                employerUnit: item.employer_id,
                                                selectedTrainingPartner: item.partner_id,
                                                isAudit: item.audit_enable
                                             }
                                          )
                                       })
                                    }

                                    actions={[
                                       hasPermission("user", "update") && (
                                          {
                                             icon: () => <i className={`${KEY_ICON}`} title="Reset Password"></i>,
                                             onClick: (e, rowData) => resetPasswordHandler(rowData),
                                          }
                                       ),
                                       hasPermission("user", "update") && (
                                          {
                                             icon: () => <i className={`${EDIT_ICON}`} title="Edit User"></i>,
                                             onClick: (event, rowData) => addEditUserHandler(rowData)
                                          }
                                       ),
                                       hasPermission("user", "delete") && (
                                          {
                                             icon: () => <i className={`${TRASH_ICON}`} title="Delete User"></i>,
                                             onClick: (event, rowData) => handleDelete(rowData)
                                          }
                                       )
                                    ].filter(Boolean)}
                                    options={{
                                       actionsColumnIndex: -1,
                                       headerStyle: {
                                          color: '#999998',
                                          fontWeight: 'bolder',
                                          fontSize: 15
                                       },
                                       filtering: true,
                                       sorting: true,
                                       columnsButton: true,
                                       exportButton: true,
                                       exportFileName: "User Data"
                                    }}
                                 />
                              </ThemeProvider>
                           ) : (
                              <div className="text-center pt-2">
                                 <label>User records not found!</label>
                              </div>
                           )
                        }
                     </div>
                  </div>
               </div>
            )}
         {
            openResetPasswordModal && (
               <ResetPasswordComponent modelOpen={openResetPasswordModal} closeModel={cancelHandle} userData={userData} />
            )}
      </>
   );
}

export default UserPage;